import Typography from "@mui/material/Typography";
import React from "react";
import { type SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import CustomSelect from "../components/CustomSelect";
import { getMonthOptions } from "../constants";
import { localeState, monthState } from "../store";
import Grid2 from "@mui/material/Grid2";
import type { SelectOptions } from "../types";

export default function Month() {
	const [month, setMonth] = useRecoilState(monthState);
	const resolvedLocale = useRecoilValue(localeState);
	const [monthOptions, setMonthOptions] = React.useState(
		getMonthOptions(resolvedLocale.shortMonthOptions),
	);

	return (
		<>
			<Grid2 container>
				<Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
					<Typography>{resolvedLocale.inText}</Typography>
					<CustomSelect
						options={monthOptions}
						label={resolvedLocale.monthLabel}
						value={month}
						setValue={
							setMonth as SetterOrUpdater<SelectOptions | SelectOptions[]>
						}
						disableClearable
						sort
						disableEmpty
					/>
				</Grid2>
			</Grid2>
		</>
	);
}
